import { Injectable } from '@angular/core';

import { Docorga } from '@docorga-v1/docorga-common';

import { DataService } from './data.service';
import { DocumentService } from './document.service';

@Injectable()
export class InvoiceService extends Docorga.services.InvoiceService {
  constructor(DataService: DataService, DocumentService: DocumentService) {
    super(DataService, DocumentService);
  }
}
